import { r as t, h as i } from "./main-bb89b2f2.js";
import "vue";
const r = class {
  constructor(e) {
    t(this, e);
  }
  render() {
    return i("slot", { key: "a4d31712cd6763ff2c366e8fe90a845c1db4076a" });
  }
};
r.style = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}";
export {
  r as patternlib_storytabs_substeps
};
